module.exports = __webpack_public_path__ + "img/guide-body-2-2.0a7caaca.png";